module.exports = __webpack_public_path__ + "img/share.5504f13d.svg";